import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import PartnershipWithPFSLabel from "app/pages/.shared/PartnershipWithPFSLabel/PartnershipWithPFSLabel";
import { memo } from "react";
import "./ListingActionbar.scss";
import PaymentDescriptionTermsContainer from "app/pages/Booking/Payment/PaymentDescriptionTerms/PaymentDescriptionTermsContainer";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";

const ListingActionbar = ({ count, showPfsMessage }) => {
	let leftSideComponent = null;
	if (showPfsMessage) {
		leftSideComponent = <PartnershipWithPFSLabel />;
	}

	return (
		<div className="listing-actionbar">
			{leftSideComponent}

			{count > 0 && (
				<Typography
					variant={TYPOGRAPHY_VARIANTS.XL3}
					variantMD={TYPOGRAPHY_VARIANTS.XL4}
					isBold
					className="listing-actionbar__counter"
					data-testid="listing-actionbar-count"
					component="h2"
				>
					<FormattedMessage id="listing.products.current.label" />
				</Typography>
			)}
			<PaymentDescriptionTermsContainer />
		</div>
	);
};

ListingActionbar.propTypes = {
	count: PropTypes.number,
	showPfsMessage: PropTypes.bool,
};

export default memo(ListingActionbar);
